import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import z from "zod";

import { requireRole } from "@/auth/shared";
import { db } from "@/db/connection";
import { notFound } from "@/lib/responses";

export const getUserSchema = z.object({
  id: z.string(),
});

export const getUserFn = createServerFn()
  .middleware([requireRole(["admin", "superadmin"])])
  .inputValidator(getUserSchema)
  .handler(async ({ data: { id } }) => {
    const user = await db.query.users.findFirst({
      where: { id },
      with: {
        profiles: {
          with: {
            level: true,
            activeMembership: {
              columns: { id: true, tshirtSize: true },
            },
          },
        },
        userProfiles: {
          with: {
            playerProfile: {
              with: {
                level: {
                  columns: {
                    name: true,
                    abbreviated: true,
                  },
                },
                activeMembership: {
                  columns: { id: true, tshirtSize: true },
                },
              },
            },
          },
        },
      },
    });

    if (!user) {
      throw notFound();
    }

    return user;
  });

export const getUserQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["admin", "user", id],
    queryFn: () => getUserFn({ data: { id } }),
  });
